/** "business" module DTOs unique keys */
export enum BusinessDtoKeysEnum {
  /** Deal order response body */
  DEAL_ORDER_FIND_DTO = 'business/deal-order-find.dto',
  /** Deal order create or update request body */
  DEAL_ORDER_FORM_DTO = 'business/deal-order-form.dto',
  /** Query parameters (additional options) for find one deal API */
  DEAL_FIND_ONE_QUERY_DTO = 'business/deal-find-one-query.dto',
  /** Deal response body */
  DEAL_FIND_DTO = 'business/deal-find.dto',
  /** Deal page response body */
  DEAL_PAGE_FIND_DTO = 'business/deal-page-find.dto',
  /** Deal status response body */
  DEAL_STATUS_FIND_DTO = 'business/deal-status-find.dto',
  /** Deal group response body */
  DEAL_GROUP_FIND_DTO = 'business/deal-group-find.dto',
  /** Deal fact time response body */
  DEAL_FACT_TIME_FIND_DTO = 'business/deal-fact-time-find.dto',
  /** Document statistic response body */
  DOCUMENT_STATISTIC_FIND_DTO = 'business/document-statistic-find.dto',
  /** File attached to deal response body */
  DEAL_FILE_FIND_DTO = 'business/deal-file-find.dto',
  /** Deal synchronize history response body */
  DEAL_SYNCHRONIZE_HISTORY_FIND_DTO = 'business/deal-synchronize-history-find.dto',
  /** Deal registry page response body */
  DEAL_REGISTRY_PAGE_DTO = 'business/deal-registry-page.dto',
  /** Query parameters (additional options) for search deal API */
  DEAL_SEARCH_QUERY_DTO = 'business/deal-search-query.dto',
  /** Deal creation and updating requests body */
  DEAL_FORM_DTO = 'business/deal-form.dto',
  /** Deal creation requests body */
  DEAL_CREATE_DTO = 'business/deal-create.dto',
  /** Some activity planned as part of the deal */
  DEAL_EVENT_FIND_DTO = 'business/deal-event-find.dto',
  /** Deal event creation and updating requests body */
  DEAL_EVENT_FORM_DTO = 'business/deal-event-form.dto',
  /** Deal partial updating requests body */
  DEAL_PARTIAL_UPDATE_FORM_DTO = 'business/deal-partial-update-form.dto',
  /** Deals list request(s) search query */
  DEALS_SEARCH_QUERY_DTO = 'business/deals-search-query.dto',
  /** Deals groups list with pagination query parameters */
  DEALS_GROUPS_PAGE_QUERY_DTO = 'business/deals-groups-page-query.dto',
  /** Deal history find body */
  DEAL_HISTORY_FIND_DTO = 'business/deal-history-find.dto',
  /** Deal history response with pagination API response body */
  DEAL_HISTORY_PAGE_DTO = 'business/deal-history-page.dto',
  /** Deal event type find request body */
  DEAL_EVENT_TYPE_FIND_DTO = 'business/deal-event-type-find.dto',
  /** Deal event type creation and updating requests body */
  DEAL_EVENT_TYPE_FORM_DTO = 'business/deal-event-type-form.dto',
  /** Deal event finish parameters */
  DEAL_EVENT_FINISH_DTO = 'business/deal-event-finish.dto',
  /** Deal event query parameters */
  DEAL_EVENT_QUERY_DTO = 'business/deal-event-query.dto',
  /** Deal event rescheduling parameters */
  DEAL_EVENT_RESCHEDULING_DTO = 'business/deal-event-rescheduling.dto',
  /** Deal helpdesk task form requests body */
  DEAL_HELPDESK_TASK_FORM_DTO = 'business/deal-helpdesk-task-form.dto',
  /** Query parameters (additional options) for search deal API */
  DEAL_HELPDESK_TASK_QUERY_DTO = 'business/deal-helpdesk-task-query.dto',
  /** Projects add and remove APIs requests body */
  DEAL_PROJECT_FORM_DTO = 'business/deal-project-form.dto',
  /** Query parameters (additional options) for search deal API */
  DEAL_PROJECT_QUERY_DTO = 'business/deal-project-query.dto',
  /** Deals tree response body element */
  DEALS_TREE_ITEM_FIND_DTO = 'business/deals-tree-item-find.dto',
  /** Deals tree search query parameters */
  DEALS_TREE_QUERY_DTO = 'business/deals-tree-query.dto',
  /** Deals group create or update request body */
  DEALS_GROUP_FORM_DTO = 'business/deals-group-form.dto',
  /** Deal status create or update request body */
  DEAL_STATUS_FORM_DTO = 'business/deal-status-form.dto',
  /** Deals group history response body */
  DEALS_GROUP_HISTORY_FIND_DTO = 'business/deals-group-history-find.dto',
  /** Deals group history response with pagination API response body */
  DEALS_GROUP_HISTORY_PAGE_DTO = 'business/deals-group-history-page.dto',
  /** Deals groups list without pagination query parameters */
  DEALS_GROUP_LIST_QUERY_DTO = 'business/deals-group-list-query.dto',
  /** Deals groups JSON-page response with pagination API response body */
  DEALS_GROUP_PAGE_DTO = 'business/deals-group-page.dto',
  /** Query parameters with filters for JSON "page" with documents from registry related to deal */
  DEAL_REGISTRY_QUERY_DTO = 'business/deal-registry-query.dto',
  /** Deal flat list query parameters */
  DEAL_FLAT_LIST_QUERY_DTO = 'business/deal-flat-list-query.dto',
}
